'use client'

import { type ComponentProps } from 'react'
import { ButtonCTA } from '../controls/ButtonCTA'
import { useClientMounted } from '../hooks/use-client-mounted'
import { useTrackingUrl } from '../hooks/use-tracking-url'
import { buildScheduleRedirectUrl, PAID_MEDIA_CALENDLY_URL, SCHEDULE_TRACKING_OPTIONS } from '../utils/ctas'
import { loadLeadMagnetQualification } from '../utils/lead-magnet-qualification'

type Props = Omit<ComponentProps<typeof ButtonCTA>, 'href'> & {
  segmentElement: string
}

export const LeadMagnetScheduleCTA = ({ segmentElement, children, ...props }: Props) => {
  const mounted = useClientMounted()
  const isQualified = mounted && loadLeadMagnetQualification()
  const href = useTrackingUrl(buildScheduleRedirectUrl(PAID_MEDIA_CALENDLY_URL, {}), SCHEDULE_TRACKING_OPTIONS)

  if (!isQualified) return null

  return (
    <ButtonCTA href={href} segmentElement={segmentElement} {...props}>
      {children}
    </ButtonCTA>
  )
}
